import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Config } from 'src/core/config/landing-config';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-legenda',
  templateUrl: './legenda.component.html'
})
export class LegendaComponent {

  public env = environment;
  constructor(@Inject(MAT_DIALOG_DATA) public data: Config) { }
  
}
